import LeadDetails from "../leadDetails";

const WhatsappLeadDetails = ({isOpen, onClose, showClass}) => {

    if (!isOpen) return null;
    
    return (
        <LeadDetails 
            isOpen={isOpen} 
            onClose={onClose} 
            leadName="whatsapp"
            showClass={showClass}
        />
    );
};

export default WhatsappLeadDetails;

